import React from 'react';
import { KPICard } from '@/components/ui';
import type { QaStats } from '../types/construction-qa.types';

interface Props {
  stats?: QaStats;
  isLoading?: boolean;
}

export const QaKPIBoard: React.FC<Props> = ({ stats, isLoading }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <KPICard
        title="Tổng kiểm tra"
        value={stats?.totalInspections || 0}
        icon="ri-survey-line"
        variant="primary"
        isLoading={isLoading}
      />
      <KPICard
        title="Tỉ lệ đạt"
        value={stats ? Math.round((stats.passedCount / (stats.totalInspections || 1)) * 100) : 0}
        icon="ri-checkbox-circle-line"
        variant="success"
        suffix="%"
        isLoading={isLoading}
      />
      <KPICard
        title="NCR Đang mở"
        value={stats?.activeNcrCount || 0}
        icon="ri-error-warning-line"
        variant="danger"
        isLoading={isLoading}
      />
      <KPICard
        title="Điểm TB"
        value={stats?.avgScore.toFixed(1) || '0.0'}
        icon="ri-star-line"
        variant="info"
        isLoading={isLoading}
      />
    </div>
  );
};
